import React from "react";
import { Box, TextField, InputAdornment } from "@mui/material";
import { FiSearch } from "react-icons/fi";

const CustomInputBox = ({
  icon: Icon,
  placeholder = "Enter text",
  label = "",
  variant = "outlined",
  padding = "",
  size = "small",
  name = "",
  type = "text",
  width = "100%",
  backgroundColor = "#FFFFFF",
  borderRadius = "10px",
  sx = {},
  required = false,
  margin = "10px 0px",
  disabled = false,
  ...otherProperties
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-end", width: width }}>
      {/* {Icon && <Icon fontSize="small" sx={{ color: "action.active", mr: 1, my: 0.5 }} />} */}
      <TextField
        {...otherProperties} // Spread other properties here
        variant={variant}
        label={label}
        size={size}
        fullWidth
        required={required}
        disabled={disabled}
        inputProps={{
          style: {
            color: "#333", // Input text color
            fontSize: "16px", // Optional: Adjust font size
            height: "30px", // Optional: Adjust input height
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: borderRadius, // Border radius
            backgroundColor: backgroundColor,
            padding: padding,
            "& fieldset": {
              borderColor: "#ccc", // Default border color
            },
            "&:hover fieldset": {
              borderColor: "#888", // Border color on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "#9d94ed", // Border color on focus
              borderWidth: "2px", // Optional: Increase border width on focus
            },
          },
          ...sx, // Additional custom styles
        }}
        placeholder={placeholder}
        name={name}
        type={type}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">{Icon && <FiSearch size={26} />}</InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default CustomInputBox;
